<script setup>

import Badge from "@/Components/Badge.vue";
import {Link} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import {computed} from "vue";

const props = defineProps({
    product: Object,
    category: {
        type: String,
        default: null
    },
    miniImg: {
        type: Boolean,
        default: false
    },
    hover: {
        type: Boolean,
        default: false
    },
    isCurrency: {
        type: Boolean,
        default: false,
    }
})

const productHref = computed(() => props.isCurrency
    ? lotHref(props.product.lots_active[0])
    : route('products.show', props.product));

// Lots always have a slug (backfilled, not-null column - see the
// 2026_08_09_120000_add_slug_and_meta_to_lots migration), so the query-param form is only ever a
// defensive fallback, not an expected path.
const lotHref = (lot) => lot?.slug
    ? route('products.lot', {product: props.product, lot: lot.slug})
    : route('products.show', {product: props.product, lot_id: lot.id});

</script>

<template>

        <div class="col-span-1 flex gap-2.5 relative
    border-b border-dashed border-slate-300 dark:border-slate-700 row-span-1 overflow-hidden"
             :class="[{'px-2.5': !miniImg}]">
            <div class="flex gap-2.5 py-2.5 px-2.5 pr-0 lg:pr-2.5 overflow-hidden group" :class="{'w-full px-5 hover:bg-slate-100 dark:hover:bg-slate-700': hover}">
                <Link :href="productHref" :class="miniImg? 'h-15 w-15' : 'h-15 w-15 lg:w-25 lg:h-25'" class="shrink-0 block">
                    <img :src="product.image_url" :alt="product.title" class="rounded-lg drop-shadow-md object-contain" :style="miniImg ? 'width: 60px; height: 60px': 'width: 100px; height: 100px'">
                </Link>
                <div class="shrink grow overflow-hidden">
                    <Link :href="productHref" class="block px-1 lg:p-1 leading-full">
                        <span class="text-sm lg:text-base font-medium dark:text-slate-200 tracking-wider group-hover:underline uppercase leading-full">{{
                            product.title
                        }}</span>
                    </Link>
                    <Link v-if="product.min_price_formatted" :href="productHref" class="block px-1 lg:p-1">
                        <span class="text-xs lg:text-sm font-medium text-slate-500 dark:text-slate-400">{{ $t('from :price', {price: product.min_price_formatted}) }}</span>
                    </Link>

                    <div class="hidden lg:px-1 pt-2 lg:flex gap-x-2 gap-y-3 flex-wrap ">
                        <Link v-for="lot in product.lots_active" :key="lot.id" :href="lotHref(lot)" class="inline-block">
                            <Badge type="info"
                                   :content-classes="['h-5', 'inline-block', 'hover:bg-slate-300', 'dark:hover:bg-slate-700', 'cursor-pointer']">
                                <template #content>
                                    <span class="align-sub text-black dark:text-slate-200 dark:text-slate-200">{{ lot.title }}</span></template>
                            </Badge>
                        </Link>
                    </div>
                    <div class="pt-2 flex gap-x-2 gap-y-3 flex-wrap lg:hidden">
                        <Link v-for="lot in product.lots_active" :key="lot.id" :href="lotHref(lot)" class="inline-block">
                            <Badge type="info"
                                   :content-classes="['h-5', 'inline-block', 'hover:bg-slate-300', 'dark:hover:bg-slate-700', 'cursor-pointer']">
                                <template #content>
                                    <span class="align-sub text-black dark:text-slate-200">{{ lot.title }}</span></template>
                            </Badge>
                        </Link>
                    </div>


                </div>
            </div>

        </div>

</template>

<style scoped>

</style>
